// this is necessary to add htmx to the window object
import htmx from 'htmx.org';
window.htmx = htmx;
